import { render, staticRenderFns } from "./ModalTour.vue?vue&type=template&id=210ea411&scoped=true&"
import script from "./ModalTour.vue?vue&type=script&lang=js&"
export * from "./ModalTour.vue?vue&type=script&lang=js&"
import style0 from "./ModalTour.vue?vue&type=style&index=0&id=210ea411&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210ea411",
  null
  
)

export default component.exports